/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Bus from '@/services/Bus'
import Config from '@/config'

export default {
  list (ctx) {
    if (!ctx.rootGetters['user/isLogged']) {
      return Promise.reject(new Error('user not logged'))
    }
    return Bus.get(Config.API.order.list, {
      params: {
        websiteId: ctx.rootGetters['storeConfig/websiteId'],
        storeViewCode: ctx.rootState.ui.storeViewCode,
        token: ctx.rootState.user.token,
        page: Math.ceil(ctx.state.pagination.start / ctx.state.pagination.size) + 1,
        limit: ctx.state.pagination.size,
        orderBy: 'entity_id'
      }
    }).then(res => {
      ctx.commit('setOrders', res.data.items)
      ctx.commit('setPagination', { ...ctx.state.pagination, total: res.data.total_count })
      return res.data
    })
  },
  getOrderById (ctx, orderInfo) {
    // API
    let query = Config.API.order.single
    query = query.replace('{{orderId}}', orderInfo.orderId)
    const params = {
      storeViewCode: ctx.rootState.ui.storeViewCode,
      token: ctx.rootState.user.token
    }
    if (orderInfo.incrementId) {
      params.incrementId = orderInfo.incrementId
    }
    return Bus.get(query, {
      params
    }).then(res => {
      ctx.commit('setOrder', res.data)
      return res.data
    }).catch(error => {
      throw error
    })
  },
  getOrderByIdAndEmail (ctx, orderInfo) {
    // API
    let query = Config.API.order.single
    query = query.replace('{{orderId}}', orderInfo.orderId)
    let params = {
      storeViewCode: ctx.rootState.ui.storeViewCode,
      email: orderInfo.email
    }
    if (orderInfo.incrementId) {
      params.incrementId = orderInfo.incrementId
    }
    return Bus.get(query, {
      params: params
    }).then(res => {
      ctx.commit('setOrder', res.data)
      return res.data
    })
  },
  getShipmentsByOrderId (ctx, orderInfo) {
    // API
    let query = Config.API.order.shipments
    query = query.replace('{{orderId}}', orderInfo.orderId)
    return Bus.get(query, {
      params: {
        storeViewCode: ctx.rootState.ui.storeViewCode
      }
    }).then(res => {
      return res.data
    })
  }
}
